import { render, staticRenderFns } from "./Ncr.vue?vue&type=template&id=1a273044&"
import script from "./Ncr.vue?vue&type=script&lang=js&"
export * from "./Ncr.vue?vue&type=script&lang=js&"
import style0 from "./Ncr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Ncr.vue"
export default component.exports